export default __webpack_public_path__ + "static/media/EE.90cf8473.svg";